"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphqlApi = void 0;
const client_1 = require("@apollo/client");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const JsonUtil_1 = require("../cutil/JsonUtil");
const MeObject_1 = require("../api/graphqlTyped/MeObject");
const RelationSetDest_1 = require("../api/graphqlTyped/RelationSetDest");
const GraphqlUtil_1 = require("../api/GraphqlUtil");
const GraphqlClient_1 = require("../cutil/GraphqlClient");
const StudioProject_1 = require("../project/domain/StudioProject");
const FunctionV2Object_1 = require("../api/graphqlTyped/FunctionV2Object");
const ObjectSetRaceObject_1 = require("../api/graphqlTyped/ObjectSetRaceObject");
class GraphqlApi {
    constructor(apolloRequest) {
        this.apolloRequest = apolloRequest;
    }
    async me() {
        const query = new GraphqlClient_1.GraphqlQuery("me", (0, client_1.gql) `
        query me {
          me {
            id
            objectId
          }
        }
      `);
        return this.apolloRequest.query(query).then(res => {
            return res.toModel(MeObject_1.MeObject, x => x.data?.me);
        });
    }
    async getStudioProject(projectId, globalOnly = true) {
        const filter = {
            attrIndexer: projectId,
            orderBy: "-created_at",
            page: 1,
            size: 1,
            globalOnly: globalOnly,
        };
        const filterStr = (0, GraphqlUtil_1.getFilterString)(filter);
        const query = new GraphqlClient_1.GraphqlQuery("objects", (0, client_1.gql) `
        query objects{
          objects(${filterStr}) {
            id
            name
            attributes
            attributesV2
            createdAt
            updatedAt
            uuid
            attrIndexer
            user {
                id
            }
          }
        }`);
        return this.apolloRequest.query(query).then(x => {
            if ((0, is_blank_1.default)(x.data?.objects)) {
                return x.valueOf(undefined);
            }
            const res = x.toModel(StudioProject_1.StudioProject, x => x.data.objects[0]);
            // const data = JSON.parse(JsonUtil.stringify(res) || "");
            return res;
        });
    }
    async getStudioProjectInfo(filter, field) {
        const filterStr = (0, GraphqlUtil_1.getFilterString)(filter);
        const query = new GraphqlClient_1.GraphqlQuery("objects", (0, client_1.gql) `
        query objects{
          objects(${filterStr}) {
            ${field}
          }
        }`);
        return this.apolloRequest.query(query).then(x => {
            if ((0, is_blank_1.default)(x.data?.objects)) {
                return x.valueOf(undefined);
            }
            const res = x.toModel(StudioProject_1.StudioProject, x => x.data.objects[0]);
            // const data = JSON.parse(JsonUtil.stringify(res) || "");
            return res;
        });
    }
    async createObject(name, attributes, isGlobal = false) {
        const query = new GraphqlClient_1.GraphqlQuery(
        // FIXME: 解决类型问题
        isGlobal ? "createObject" : "createObject", (0, client_1.gql) `
        mutation createObject($data: ObjInput!) {
          createObject(data: $data) {
            ok
            object {
              attributes
              attributesV2
              id
              attrIndexer
              createdAt
              name
              uuid
              updatedAt
            }
          }
        }
      `, {
            data: {
                attributes: attributes,
                name: name,
            },
        });
        return this.apolloRequest
            .mutate(query)
            .then(x => {
            console.log(x.data);
            if ((0, is_blank_1.default)(x.data?.createObject?.object)) {
                return x.valueOf(undefined);
            }
            return x.data.createObject.object;
        })
            .catch(error => {
            console.log("GraphqlApi createObject:", error);
        });
    }
    async createStudioProject(projectData, isGlobal = false) {
        const jsonData = JSON.parse(JsonUtil_1.JsonUtil.stringify(projectData) || "");
        return this.createObject("studio_project", jsonData.attributes, isGlobal);
    }
    async createImagicaAppSnapshot(projectData) {
        const jsonData = JSON.parse(JsonUtil_1.JsonUtil.stringify(projectData) || "");
        return this.createObject("imagica_app_snapshot", jsonData.attributes, true);
    }
    // async getStudioProjectAttributes(projectId: string): Promise<void> {
    //   const params = {
    //     name: "studio_project",
    //     attrIndexer: projectId,
    //     orderBy: "-created_at",
    //     page: 1,
    //     size: 1,
    //   };
    // }
    async getFunctions(filter) {
        if (typeof filter?.id === "string") {
            filter.id = parseInt(filter.id);
        }
        const filterStr = (0, GraphqlUtil_1.getFilterString)(filter);
        const query = new GraphqlClient_1.GraphqlQuery("objects", (0, client_1.gql) `
        query objects{
          objects(${filterStr}) {
            id
            name
            attributes
            createdAt
            updatedAt
            uuid
            attrIndexer
            user {
              id
              firstName
              lastName
            }
          }
        }`);
        return this.apolloRequest.query(query).then(x => {
            if ((0, is_blank_1.default)(x.data?.objects)) {
                return x.valueOf(undefined);
            }
            return x.toArray(RelationSetDest_1.RelationSetDest, x => x.data.objects || []);
        });
    }
    async getEdgeFunctions(filter) {
        const filterStr = (0, GraphqlUtil_1.getFilterString)(filter);
        const query = new GraphqlClient_1.GraphqlQuery("objects", (0, client_1.gql) `
        query objects{
          objects(${filterStr}) {
            id
            name
            attributes
            attributesV2
            createdAt
            updatedAt
            uuid
            attrIndexer
            user {
              id
              firstName
              lastName
            }
          }
        }`);
        return this.apolloRequest.query(query).then(x => {
            if ((0, is_blank_1.default)(x.data?.objects)) {
                return x.valueOf(undefined);
            }
            return x.toArray(RelationSetDest_1.RelationSetDest, x => x.data.objects || []);
        });
    }
    async relationSetDestList(filters) {
        // temp increase size to 1000, need pagination UI
        const filterStr = (0, GraphqlUtil_1.getFilterString)(Object.assign({}, { page: 1, size: 1000 }, filters));
        const query = new GraphqlClient_1.GraphqlQuery("relationSet", (0, client_1.gql) `
        query relationSet{
          me {
            relationSet(${filterStr}){
              id
              dest {
                id
                name
                attributes
                createdAt
                updatedAt
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }`);
        return this.apolloRequest.query(query).then(res => {
            return res.toArray(RelationSetDest_1.RelationSetDest, () => {
                return (res?.data?.me.relationSet || []).map((x) => {
                    let dest = x?.dest;
                    if (dest && typeof dest === "object") {
                        dest = Object.assign({}, dest, { relationId: x.id });
                    }
                    return dest;
                });
            });
        });
    }
    async getPersonalFunctions(filters) {
        // temp increase size to 1000, need pagination UI
        const filterStr = (0, GraphqlUtil_1.getFilterString)(Object.assign({}, { page: 1, size: 1000 }, filters));
        const query = new GraphqlClient_1.GraphqlQuery("relationSet", (0, client_1.gql) `
        query relationSet{
          me {
            relationSet(${filterStr}){
              id
              dest {
                id
                name
                attributes
                attributesV2
                createdAt
                updatedAt
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }`);
        return this.apolloRequest.query(query).then(res => {
            return res.toArray(RelationSetDest_1.RelationSetDest, () => {
                return (res?.data?.me.relationSet || []).map((x) => {
                    let dest = x?.dest;
                    if (dest && typeof dest === "object") {
                        dest = Object.assign({}, dest, { relationId: x.id });
                    }
                    return dest;
                });
            });
        });
    }
    async getFunctionV2(page, size) {
        const query = new GraphqlClient_1.GraphqlQuery("objects", (0, client_1.gql) `
        query objects {
          objects(name: "studio_function_v2", globalOnly: true, size: ${size}, page: ${page}) {
            id
            attributesV2
            user {
              id
            }
          }
        }
      `);
        return this.apolloRequest.query(query).then(x => {
            return x.toArray(FunctionV2Object_1.FunctionV2Object, x => x.data.objects || []);
        });
    }
    async objectSetRace(filters) {
        const query = new GraphqlClient_1.GraphqlQuery("objectSet", (0, client_1.gql) `
      query objectSet{
        getByAttrIndexer: me {
          objectSet(attrIndexer: "${filters.attrIndexer}") {
            id
            attrIndexer
            uuid
            attributes
            attributesV2
            updatedAt
          }
        }
        getByUUID: me {
          objectSet(uuid: "${filters.attrIndexer}") {
            id
            uuid
            attributes
            attributesV2
            attrIndexer
            updatedAt
          }
        }
      }`);
        return this.apolloRequest.query(query).then(x => {
            const model = x.toModel(ObjectSetRaceObject_1.ObjectSetRaceObject, res => res.data);
            return model;
        });
    }
    async getPersonalProjectNumber() {
        const query = new GraphqlClient_1.GraphqlQuery("relationSet", (0, client_1.gql) `
        query relationSet {
          me {
            relationSet(page: 1, size: 101, name: "studio_project") {
              id
            }
          }
        }
      `);
        return this.apolloRequest.query(query).then(res => {
            return (res.data.me.relationSet ?? []).length;
        });
    }
    async queryObject(filters = {}, params = {}, idFilter = {}) {
        const { size = 1000, page = 1, orderBy = "-created_at" } = params;
        if (typeof idFilter?.destId === "string") {
            idFilter.destId = parseInt(idFilter.destId);
        }
        const filterStr = (0, GraphqlUtil_1.getFilterString)(Object.assign({}, { page, size, orderBy }, filters, idFilter));
        const query = new GraphqlClient_1.GraphqlQuery("relationSet", (0, client_1.gql) `
        query relationSet {
          me {
            relationSet(${filterStr}) {
              id
              dest {
                id
                uuid
                attrIndexer
                name
                attributes
                attributesV2
                createdAt
                updatedAt
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      `);
        return this.apolloRequest.query(query).then(res => {
            return res.toArray(RelationSetDest_1.RelationSetDest, res => {
                return (res?.data?.me.relationSet || []).map((x) => {
                    let dest = x?.dest;
                    if (dest && typeof dest === "object") {
                        dest = Object.assign({}, dest, { relationId: x.id });
                    }
                    return dest;
                });
            });
        });
    }
}
exports.GraphqlApi = GraphqlApi;
